import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configBonusHandle } from '@/api/apis';
export default {
  props: {
    bonusData: {
      required: true
    },
    levelList: {
      required: true
    }
  },
  watch: {
    bonusData: function bonusData(newVal, oldVal) {
      this.conditions = JSON.parse(newVal.conditions);
    },
    deep: true,
    // 如果 bonusData 是对象或数组，需要这个
    immediate: false // 是否在初始时立即触发一次

  },
  data: function data() {
    return {
      conditions: [// {level:1,layer:1,rate:0.002},
        // {level:2,layer:3,rate:0.002},
        // {level:3,layer:6,rate:0.002},
      ]
    };
  },
  mounted: function mounted() {},
  methods: {
    getLevelName: function getLevelName(level) {
      for (var i in this.levelList) {
        if (this.levelList[i].tag == level) {
          return this.levelList[i].name;
        }
      }

      return "";
    },
    clickSave: function clickSave() {
      var _this = this;

      configBonusHandle({
        id: this.bonusData.id,
        conditions: JSON.stringify(this.conditions)
      }).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};